import { IProducts } from '@/repositories/product.interface';
import { CheckFileResponse, Records } from '@/repositories/virtualCardRepository';

type ProductToCart = {
  id: number | string;
  quantity: number;
  price: number;
  name: string;
  iddelivery: number;
  analyticsData: object;
}

type DataFromFile = {
  count: number,
  records: Records[],
  totalAmount: number;
}

export const productToCartFactory = ({ idproducts, price, name }: IProducts, deliveryId: number, quantity: string, charge: string | number, analyticsDataObject: object) : ProductToCart => ({
  id: idproducts,
  iddelivery: deliveryId,
  name,
  price: typeof charge === 'string' ? parseFloat(charge) : charge,
  quantity: parseFloat(quantity),
  analyticsData: analyticsDataObject,
});

export const createProductToCartData = (data:DataFromFile, productData: IProducts, deliveryId: number) : ProductToCart[] => {
  const result: ProductToCart[] = [];
  data.records.forEach((item, index) => {
    const newIndex = index === 0 ? `${productData.idproducts}` : `${productData.idproducts}-${index}`;

    const productWithNewId = {
      ...productData,
      idproducts: newIndex,
    };
    const productObject = productToCartFactory(productWithNewId, deliveryId, '1', item.amount, productData.analyticsData);
    result.push(productObject);
  });
  return result;
};
